import React from 'react';
import { ToastContainer } from 'react-toastify';
import Box from '@mui/material/Box';
import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import ToastFeedbackId from '@/constants/ui/ToastFeedbackId';
import CloseButton from './CloseButton';
import 'react-toastify/dist/ReactToastify.css';

const TOAST_AUTO_CLOSE_TIME = 5000;
const TOASTS_LIMIT = 3;

type ToastFeedbackProps = {
  containerId: string;
  stickToModule: boolean;
};

type ToastFeedbackStyleProps = Pick<ToastFeedbackProps, 'stickToModule'>;

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    '& .Toastify__toast-container': {
      position: ({ stickToModule }: ToastFeedbackStyleProps) =>
        stickToModule ? 'relative' : 'fixed',
      top: 0,
      width: ({ stickToModule }: ToastFeedbackStyleProps) =>
        stickToModule ? '100%' : '100vw',

      '& .Toastify__toast': {
        borderRadius: theme.shape.borderRadius,
        boxShadow: 'none',
        color: 'rgb(var(--color-text-primary))',
        marginBottom: theme.spacing(0.5),
        minHeight: 44,
        padding: `0 ${theme.spacing(1.5)}`,

        '&--success': {
          backgroundColor: theme.palette.success.light,
          border: '1px solid',
          borderColor: theme.palette.success.main,
        },
        '&--error': {
          backgroundColor: theme.palette.error.light,
          border: '1px solid',
          borderColor: theme.palette.error.main,
        },
        '&--warning': {
          backgroundColor: theme.palette.warning.light,
          border: '1px solid',
          borderColor: theme.palette.warning.main,
        },
      },
    },
  },
}));

function ToastFeedback({
  containerId = ToastFeedbackId.APP,
  stickToModule = false,
}: ToastFeedbackProps) {
  const classes = useStyles({ stickToModule });

  return (
    <Box className={classes.container}>
      <ToastContainer
        autoClose={TOAST_AUTO_CLOSE_TIME}
        containerId={containerId}
        closeButton={CloseButton}
        enableMultiContainer
        hideProgressBar
        newestOnTop
        limit={TOASTS_LIMIT}
        position="top-center"
      />
    </Box>
  );
}

export default ToastFeedback;
